  import {
    Form,
    FormInstance,
    Input,
    Select,
  } from "antd";
  import { FC } from "react";
  import styled from "@emotion/styled";
  import TextArea from "antd/es/input/TextArea";

  interface CreateTaxAddressFormProps {
    form: FormInstance;
  }

  const { Option } = Select;

  const CreateTaxAddressForm: FC<CreateTaxAddressFormProps> = ({
    form, 
  }) => {
    return (
      <FormWrapper>
        <FormItems
          labelAlign="left"
          label="ชื่อ-สกุล/ชื่อบริษัท"
          name="name"
          rules={[{ required: true, message: "กรุณากรอกชื่อ-สกุล/ชื่อบริษัท" }]}
        >
          <Input
              placeholder="ชื่อ-สกุล/ชื่อบริษัท"
              size="small"
              autoComplete="off"
          />     
        </FormItems>
        <FormItems
            label="ที่อยู่"
            labelAlign="left"
            name="address"
            rules={[{ required: true, message: "กรุณากรอกที่อยู่" }]}
          >
            <TextArea placeholder="ที่อยู่" rows={5} />  
        </FormItems>

        <FormItems
          labelAlign="left"
          label="เบอร์โทรศัพท์"
          name="telephone"
          rules={[
            { required: true, message: "กรุณากรอกเบอร์โทรศัพท์" },
            // { validator: validatePhoneNumber },
          ]}
        >
          <Input
              placeholder="เบอร์โทรศัพท์"
              size="small"
              autoComplete="off"
          />     
        </FormItems>
        <FormItems
          labelAlign="left"
          label="เลขประจำตัวผู้เสียภาษี"
          name="tax_no"
          rules={[
            { required: true, message: "กรุณากรอกเลขประจำตัวผู้เสียภาษี" },
            // { validator: validatePhoneNumber },
          ]}
        >
          <Input
              placeholder="เลขประจำตัวผู้เสียภาษี"
              size="small"
              autoComplete="off"
          />     
        </FormItems>
      </FormWrapper>
    );
  };

  export default CreateTaxAddressForm;

  const FormItems = styled(Form.Item)`
      margin-bottom: 10px;
      width:100%
  `
  const FormWrapper = styled.div`
    width: 100%;
    height: 100%;
    padding: 20px 20px 2px 20px;
    background-color: #ffffffff;
  `;